import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Autocomplete from "../common/Autocomplete";
import Query from "../common/Query";
import { SendRRDRequest } from "./components/SendRRDRequest";
import ALLCHAPTERS_QUERY from "./queries/ALLCHAPTERS_QUERY";
import AlertDismissible from "../common/AlertDismissible";
import { AppContext } from "../store";
import { useQueryParam } from "../hooks/useQueryParam";

const PrintView = () => {
  const { state } = useContext(AppContext);
  const [chapter, setChapter] = useState("");
  let query = useQueryParam();
  const navigate = useNavigate();
  let status = query.get("status");
  let error = query.get("error");
  const handleSelect = (data: any) => setChapter(data[0]?.SiteID);
  return (
    <>
      {status && (
        <AlertDismissible
          handleClose={() => navigate("/print")}
          variant={error ? "danger" : "success"}
        >
          {status}
        </AlertDismissible>
      )}
      <h1>RR Donnelley Mailing List</h1>
      <Query query={ALLCHAPTERS_QUERY}>
        {({ data: { chapterList } }: { data: { chapterList: any[] } }) => {
          const select = (
            <Autocomplete
              id="print-view-chapter-list"
              options={chapterList}
              filterKey={"Chapter"}
              label="Select a Chapter"
              placeholder="Search chapter list ..."
              onSelect={handleSelect}
            />
          );
          return (
            <>
              {select}
              <div className="mt-3">
                <SendRRDRequest
                  chapter={chapter}
                  email={state?.accountInfo?.username}
                />
              </div>
            </>
          );
        }}
      </Query>
    </>
  );
};

export default PrintView;
